import axios from 'axios';

let interval;
let currentSPAVersion;

function getCurrentSPAVersion(){
    const currentScript = document.currentScript;
    let version = false;
    if (currentScript){
        let scriptPath = currentScript.getAttribute('src');
        const match = /main\.([a-z0-9]{8})\./.exec(scriptPath);
        if (match) {
            version = match[1];
        }
        return version;
    }
    else return version;
}

currentSPAVersion = getCurrentSPAVersion();

console.log(currentSPAVersion);

function checkSPAVersionAndRefresh(spaOutdated, autoRefresh = false) {
    if(spaOutdated && spaOutdated === "outdated"){
        clearInterval(interval);
        autoRefresh ? window.location.reload(true) : document.querySelector("#spa-update").classList.add("active");
    }
}

function request(req){
    if (!!currentSPAVersion && !!process.env.REACT_SPA_VERSION_CHECK) {
        req.headers["spa-version"] = currentSPAVersion;
    }
    return req;
}

function response(res) {
    if(!!process.env.REACT_SPA_VERSION_CHECK){
        checkSPAVersionAndRefresh(res.headers['spa-version-outdated']);
    }

    return res;
}

function fetchSPAVersion(cb = (res)=>{}){
    axios.get(`${process.env.REACT_APP_BASE_API}/spa-version-check?v=${currentSPAVersion}`, {timeout:5000}).then(res=>cb(res)).catch(e=>console.log(e));
}

/*
function handleNetworkError(error) {
    if (window.location.pathname !== '/maintenance') {
        if (window.plausible) {
            const fullURL = new URL(error?.config.url, error?.config.baseURL);
            window.plausible('ERR_NETWORK', {
                props: {
                    url: error?.config.url,
                    path: fullURL.pathname,
                    search: fullURL.search,
                    method: error?.config.method
                }
            });
            console.warn(`ERR_NETWORK ${error?.config.method} ${error?.config.url}`);
        }
        sessionStorage.setItem('maintenance-backup-path', window.location.pathname);
        sessionStorage.setItem('maintenance-type', 'server');
        console.warn("Network Error: Redirecting to maintenance page.");
        window.location.href = '/maintenance';
    }
}



function fetchSPAVersion(cb = (res) => {}) {
  axios
    .get(`${process.env.REACT_APP_BASE_API}/spa-version-check?v=${currentSPAVersion}`, { timeout: 5000 })
    .then((res) => cb(res))
    .catch((error) => {
      const status = error?.response?.status;

      // Down / gateway / service indispo / timeout proxy
      if (!error?.response || [502, 503, 504].includes(status)) {
        handleNetworkError(error);
        return;
      }

      console.log(error);
    });
}*/

interval = setInterval(()=>fetchSPAVersion(res=>checkSPAVersionAndRefresh(res?.data?.status)), 60000);
fetchSPAVersion(res=>checkSPAVersionAndRefresh(res?.data?.status, true));

const SPAVersionInterceptor = {
    request,
    response
};

export default SPAVersionInterceptor;